module.exports = __webpack_public_path__ + "img/content-img.6cd07732.png";